const isResolvedCollection = require('../contentful/is-resolved-resource');
const makeTransformer = require('./make');

const createEntryLink = (entry) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Entry',
      id: entry.id
    }
  };
};

module.exports = {
  contentfulToInternal(entry) {
    // console.log('entry', entry);
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: null,
      created: new Date(entry.sys.createdAt),

      title: (entry.fields.title ? entry.fields.title['nb-NO'] : ''),
      description: (entry.fields.description ? entry.fields.description['nb-NO'] : null),

      value: (entry.fields.value ? entry.fields.value['nb-NO'] : null),
      validMonths: (entry.fields.validMonths ? entry.fields.validMonths['nb-NO'] : null),
      internalComment: (entry.fields.internalComment ? entry.fields.internalComment['nb-NO'] : null),
      availableInForms: (entry.fields.availableInForms ? entry.fields.availableInForms['nb-NO'] : false),
      availableAtDealer: (entry.fields.availableAtDealer ? entry.fields.availableAtDealer['nb-NO'] : false),
      services: (entry.fields.services ? entry.fields.services['nb-NO'] : null),
      yearNumber: (entry.fields.yearNumber ? entry.fields.yearNumber['nb-NO'] : null),
      yearOutside: (entry.fields.yearOutside ? entry.fields.yearOutside['nb-NO'] : null),
      expires: null,
      makes: null,
      modelNames: (entry.fields.modelNames ? entry.fields.modelNames['nb-NO'] : []),
      service: null // FAKE field for internal use of services JSON field
    };

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;
    }

    if (entry.fields.expires && entry.fields.expires['nb-NO']) {
      result.expires = new Date(entry.fields.expires['nb-NO']);
    }

    result.makeIds = entry.fields.makes ? entry.fields.makes['nb-NO'].map((d) => d.sys.id) : [];
    if (entry.fields.makes && entry.fields.makes['nb-NO'] && isResolvedCollection(entry.fields.makes['nb-NO'])) {
      result.makes = entry.fields.makes['nb-NO'].map(makeTransformer.contentfulToInternal);
    }

    if (result.services) {
      result.service = result.services[0];
    }

    return result;
  },

  internalToContentful(giftcard) {
    const result = {
      fields: {
        title: {
          'nb-NO': giftcard.title
        },
        description: {
          'nb-NO': giftcard.description || null
        },
        value: {
          'nb-NO': giftcard.value || null
        },
        validMonths: {
          'nb-NO': giftcard.validMonths ? parseInt(giftcard.validMonths, 10) : null
        },
        internalComment: {
          'nb-NO': giftcard.internalComment || null
        },
        availableInForms: {
          'nb-NO': giftcard.availableInForms || null
        },
        availableAtDealer: {
          'nb-NO': giftcard.availableAtDealer || null
        },
        services: {
          'nb-NO': (giftcard.availableInForms && giftcard.service) ? [giftcard.service] : null
        },
        modelNames: {
          'nb-NO': giftcard.modelNames || null
        },
        yearNumber: {
          'nb-NO': giftcard.yearNumber ? parseInt(giftcard.yearNumber, 10) : null
        },
        yearOutside: {
          'nb-NO': (giftcard.yearOutside && giftcard.yearNumber) ? !!giftcard.yearOutside : null
        },
        expires: null
      }
    };

    if (giftcard.expires) {
      // Format: YYYY-MM-DD
      result.fields.expires = {
        'nb-NO': giftcard.expires.toISOString().split('T')[0]
      };
    }

    if (typeof giftcard.makes !== 'undefined') {
      result.fields.makes = {
        'nb-NO': giftcard.makes ? giftcard.makes.map(createEntryLink) : null
      };
    }

    return result;
  }
};
